// PL
export const derivedRatesSection = {
  title: "Taryfy pochodne",
  description:
    "Twórz taryfy oparte na Twoich głównych taryfach, aby łączyć się z różnymi OTA, zachowując jedną centralną cenę bazową.",
  newRate: "Nowa taryfa pochodna",
  loading: "Wczytywanie taryf...",

  otaBadge: "OTA",
  otaLockedTitle: "Taryfa OTA: zarządzana w sekcji 'Połącz OTA'",
  salePaused: "Sprzedaż wstrzymana",

  columns: {
    name: "Nazwa",
    adjustment: "Korekta",
    finalPrice: "Cena końcowa",
  },

  actions: {
    resumeTitle: "Wznów sprzedaż w Channex",
    pauseTitle: "Wstrzymaj sprzedaż w Channex (stop_sell)",
    edit: "Edytuj",
    delete: "Usuń",
    protectedTitle: "Chroniona: zmień ją lub usuń w sekcji 'Połącz OTA'",
  },

  empty: {
    title: "Brak taryf pochodnych",
    text: "Twórz taryfy pochodne oparte na Twoich głównych taryfach, aby łączyć się z OTA",
    create: "Utwórz pierwszą taryfę pochodną",
  },

  modal: {
    editTitle: "Edytuj taryfę pochodną",
    createTitle: "Nowa taryfa pochodna",
    baseRatePlan: "Taryfa bazowa",
    selectBasePlaceholder: "Wybierz taryfę bazową",
    selectBaseHint:
      "Wybierz taryfę, na podstawie której będzie obliczana ta taryfa pochodna",
    nameLabel: "Nazwa taryfy pochodnej",
    namePlaceholder: "np. Taryfa Booking.com, Taryfa Airbnb",
    nameHint: "Ta nazwa pomoże rozpoznać taryfę podczas łączenia z OTA",
    adjustmentType: "Rodzaj korekty",
    percentage: "Procent",
    fixedAmount: "Kwota stała",
    adjustmentValue: "Wartość korekty",
    adjustmentValueHint: "(wartości ujemne oznaczają zniżkę)",
    cancel: "Anuluj",
    saving: "Zapisywanie...",
    update: "Zaktualizuj",
    create: "Utwórz taryfę",
  },

  preview: {
    title: "Podgląd",
    basePrice: "Cena bazowa",
    increment: "Podwyżka",
    discount: "Zniżka",
    finalPrice: "Cena końcowa",
  },

  delete: {
    title: "Usuń taryfę pochodną",
    warnStrong: "Tej operacji nie można cofnąć.",
    warnText:
      "Przed usunięciem upewnij się, że taryfa {name} nie jest połączona z żadną OTA.",
    confirmLabel: "Wpisz dokładną nazwę, aby potwierdzić:",
    confirmPlaceholder: "Wpisz dokładnie nazwę taryfy",
    confirmHint:
      "Wklej lub wpisz nazwę dokładnie tak, jak widnieje powyżej, aby odblokować przycisk usuwania.",
    cancel: "Anuluj",
    processing: "Usuwanie...",
    confirm: "Usuń trwale",
  },

  pause: {
    resumeTitle: "Wznów sprzedaż",
    pauseTitle: "Wstrzymaj sprzedaż",
    resumeText:
      "{code} zostanie wysłane do Channex na najbliższe 500 dni. Kanał znów zacznie otrzymywać dostępność i będzie mógł przyjmować rezerwacje.",
    pauseText:
      "{code} zostanie wysłane do Channex na najbliższe 500 dni. Kanał powiązany z tą taryfą nie będzie mógł przyjmować nowych rezerwacji, dopóki sprzedaż jest wstrzymana.",
    note: "Nie wpłynie to na główny kalendarz ani na pozostałe kanały. Aby wznowić, kliknij przycisk ▶ przy taryfie.",
    cancel: "Anuluj",
    resuming: "Wznawianie...",
    pausing: "Wstrzymywanie...",
    confirmResume: "Tak, wznów sprzedaż",
    confirmPause: "Tak, wstrzymaj sprzedaż",
  },

  toast: {
    loadError: "Błąd podczas wczytywania danych",
    fillRequired: "Uzupełnij wszystkie wymagane pola",
    updated: "Taryfa została zaktualizowana",
    created: "Taryfa została utworzona",
    saveFailed: "Nie udało się zapisać taryfy",
    saveError: "Błąd podczas zapisywania taryfy pochodnej",
    deleted: "Taryfa pochodna została usunięta",
    deleteFailed: "Nie udało się usunąć taryfy",
    deleteLinkedOta: "Nie można usunąć: taryfa jest połączona z OTA.",
    nameMismatch: "Wpisana nazwa nie jest zgodna.",
    deleteError: "Błąd podczas usuwania taryfy pochodnej",
    salesPaused: "Sprzedaż wstrzymana",
    salesResumed: "Sprzedaż wznowiona",
    toggleFailed: "Nie udało się zmienić statusu",
    toggleError: "Błąd podczas zmiany statusu taryfy",
    // Guardada en local, pero Channex no aceptó el cambio (channex_synced:false).
    channexNotSynced: "Taryfa została zapisana, ale channel manager nie przyjął zmiany: kanały mają nadal poprzednią wersję. Sprawdź dane i spróbuj ponownie.",
  },

  // Estancia mínima propia de una derivada (own_min_stay). Campo y chip
  // compartidos: OwnMinStayField.vue / OwnMinStayChip.vue.
  ownMinStay: {
    label: "Własny minimalny pobyt (noce)",
    hint: "Puste = tak samo jak w taryfie głównej",
    mixedPlaceholder: "Różne",
    mixedHint: "Każdy pokój ma inne minimum. Jeśli wpiszesz wartość, zostanie zastosowana do wszystkich; jeśli zostawisz puste, każdy zachowa swoje.",
    // Sugerencia por el nombre («Tarifa semanal» → 7): una pregunta de un clic.
    suggestQuestion: "Minimum {n} noc? | Minimum {n} noce? | Minimum {n} nocy?",
    suggestUse: "Ustaw",
    clear: "Usuń",
    channelNote: "{channel} otrzyma minimum {n} noc dla tej taryfy. | {channel} otrzyma minimum {n} noce dla tej taryfy. | {channel} otrzyma minimum {n} nocy dla tej taryfy.",
    genericNote: "Połączone kanały (Booking itp.) otrzymają minimum {n} noc dla tej taryfy. | Połączone kanały (Booking itp.) otrzymają minimum {n} noce dla tej taryfy. | Połączone kanały (Booking itp.) otrzymają minimum {n} nocy dla tej taryfy.",
    chip: "Min. {n} noc | Min. {n} noce | Min. {n} nocy",
    chipMixed: "Min. różne dla pokoi",
    chipTitle: "Własny minimalny pobyt tej taryfy: jest wysyłany do połączonych kanałów",
    // Grupo con mínimos distintos: quitárselo a todas es un gesto aparte.
    clearAll: "Usuń minimum ze wszystkich",
    clearedAllHint: "Po zapisaniu wszystkie stracą własne minimum i użyją minimum taryfy głównej.",
    undo: "Cofnij",
  },
};
